exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.text-red[data-v-7c635230] {\n  color: rgb(226, 0, 0);\n}\n", "", {"version":3,"sources":["/app/src/components/OrderTable/components/tdDeliveryNotes.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;CACvB","file":"tdDeliveryNotes.vue","sourcesContent":["\n.text-red[data-v-7c635230] {\n  color: rgb(226, 0, 0);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7c635230","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OrderTable/components/tdDeliveryNotes.vue
// module id = mfyB
// module chunks = 0